import React from 'react'
import { Scrollable } from '@lightspeed/design-system-react'
import { BackToSaleHeader } from '../../payments/back-to-sale-header/BackToSaleHeader'
import { AccountBalancePaymentSection } from './AccountBalancePaymentSection'
import { PaymentSection } from './PaymentSection'
import { ChangeAmountSection } from './ChangeAmountSection'
import { ToPaySection } from './ToPaySection'

/**
 * Summary panel for the Account Balance Payment (ABP) flow.
 *
 * Replaces the standard SummaryPanel when abpTransactionId is set. The ABP
 * flow does not create a sale, so Subtotal / Tax / Sale Total sections are
 * intentionally omitted — they would always show $0 and mislead the merchant.
 */
export const AbpSummaryPanel: React.FC = () => {
  return (
    <>
      <BackToSaleHeader />
      <hr className="vd-hr vd-hr--full vd-hide-desktop" />
      <div className="sale-summary">
        <Scrollable className="sale-summary-content">
          <AccountBalancePaymentSection />
          <PaymentSection />
          <ChangeAmountSection />
          <ToPaySection />
        </Scrollable>
      </div>
    </>
  )
}
